/** @format */

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../button';
import { Link } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';

import { Logo } from '../../configVariable';
import { UserInfo } from '../globalHeader/userInfo';
import { Dropdown } from 'antd';
import { HamburgerIcon } from '../icons';
import { menuAppDropDown } from '../globalHeader/appsDropdown';
import { Box } from '@material-ui/core';
import { LANGUAGES } from 'src/constants.js';

// Matches SCSS `@include media(md)` (min-width: 768px) used by `.userBox`
const MOBILE_HEADER_MQ = '(max-width: 767px)';

const Header = props => {
  const { userLang, getSelectLang } = props;

  const { isAuthenticated, onLogin } = useAuth();
  const { logout, user } = useAuth();
  const { i18n } = useTranslation();
  const [lang, setLang] = useState(i18n.language || 'en');
  const [isNarrowHeader, setIsNarrowHeader] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(MOBILE_HEADER_MQ).matches
  );

  useEffect(() => {
    setLang(i18n.language || 'en');
  }, [i18n.language]);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MOBILE_HEADER_MQ);
    const onChange = event => setIsNarrowHeader(event.matches);
    setIsNarrowHeader(mediaQuery.matches);
    mediaQuery.addEventListener('change', onChange);
    return () => mediaQuery.removeEventListener('change', onChange);
  }, []);

  const handleLoginAction = async () => {
    await onLogin(userLang);
  };

  const handleLogout = async () => {
    await logout();
  };

  const currentLanguage = LANGUAGES.find(item => item.value === lang);

  return (
    <header className="header">
      <div className="container">
        <div className="main-logo">
          <Link to="/dashboard">
            <img src={Logo.default} alt="Logo" />
          </Link>
        </div>
        <div className="site-list">
          <span className="active-site">
            <Link to="/dashboard">Customer support</Link>
          </span>
        </div>

        <div className="userBox">
          <Box className="menuApp">
            {menuAppDropDown(userLang).map(item => (
              <Box key={item.key}>{item.label}</Box>
            ))}
          </Box>
          {!isNarrowHeader && (
            <UserInfo
              data={user}
              logout={handleLogout}
              onLangChange={data => {
                getSelectLang({ target: { value: data } });
              }}
            />
          )}
          <Dropdown
            overlayClassName="dropDown"
            menu={{
              items: LANGUAGES.sort((a, b) => a.market.localeCompare(b.market)).map(item => ({
                key: item.value,
                label: (
                  <div
                    className={`languageMenuItem ${currentLanguage?.value === item.value ? 'languageMenuItemSelected' : ''}`}
                    onClick={() => {
                      setLang(item.value);
                      getSelectLang({ target: { value: item.value } });
                    }}
                  >
                    {item.market} | {item.value.toUpperCase()}
                  </div>
                )
              }))
            }}
            trigger={['click']}
            placement={'bottomRight'}
          >
            <Box component="span" onClick={e => e.preventDefault()} className="language-selection-button">
              {currentLanguage ? `${currentLanguage.market} | ${currentLanguage.value.toUpperCase()}` : 'Global | EN'}
            </Box>
          </Dropdown>
        </div>

        {isNarrowHeader && (
          <UserInfo
            isMobile
            data={user}
            logout={handleLogout}
            onLangChange={data => {
              getSelectLang({ target: { value: data } });
            }}
          />
        )}

        <Dropdown
          overlayClassName="header-dropdown"
          menu={{ items: menuAppDropDown(userLang) }}
          trigger={['click']}
          placement={'bottomRight'}
        >
          <Box component="span" onClick={e => e.preventDefault()} className="header-hamburger hamberger-nav">
            <i></i>
            <i></i>
            <i></i>
          </Box>
        </Dropdown>
      </div>
    </header>
  );
};

export { Header };
